import { render, staticRenderFns } from "./SectionEvents.vue?vue&type=template&id=7d6d9a20&"
import script from "./SectionEvents.vue?vue&type=script&lang=js&"
export * from "./SectionEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports